import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import {
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
  Button,
  Box
} from "@mui/material"
import { ArrowBack } from "@mui/icons-material"
import apiClient from "../../api/apiClient" 
import { showModal } from "../../redux/modalSlice"
import { getErrorMessage } from "../../modules/helpers" // Adjust path if needed
import { Container } from "@mui/system"
import BackButton from "../../components/mui/BackButton"

const TechnicianDetails = () => {
  const { id } = useParams() 
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchTechnicianData()
  }, [id])

  const fetchTechnicianData = async () => {
    setLoading(true)
    const result = await apiClient.get(`/auth/get-tech-codes-data/${id}`)
    
    setLoading(false)

    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Technician Details",
          message: getErrorMessage(result.data, "Failed to fetch technician details.")
        })
      )
      return
    }

    // Assuming your API returns { status: "success", data: { ... } }
    setData(result.data.data)
  }

  // --- Helper Renderers ---
  const getStatusChip = (status) => {
    if (status === "SUB") {
      return <Chip label="Submitted" color="success" size="small" variant="outlined" />
    }
    return <Chip label="Received" color="warning" size="small" variant="outlined" />
  }

  const formatDate = (dateString) => {
    if (!dateString) return "-"
    return new Date(dateString).toLocaleDateString()
  }

  // --- Main Render ---
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <CircularProgress />
      </div>
    )
  }

  if (!data) {
    return <div className="text-center mt-5">Technician not found.</div>
  }

  return (
    <Container className="" maxWidth="lg">
    <div className="p-3">
      {/* Header & Back Button */}
      <div className="px-2  mb-4">

      <div className=" d-flex align-items-center" >
                  <div>
                    <BackButton back />
                  </div>
           
                  <Typography className="ps-3  " variant="h4" component="h1">
          Technician Overview
        </Typography>
                </div>


 
      </div>

      {/* Stats Cards */}
      <Grid container spacing={3} className="mb-4">
        <Grid item xs={12} md={4}>
          <Paper elevation={2} className="p-3 text-center border-start border-primary border-4">
            <Typography variant="h6">Total Assigned</Typography>
            <Typography variant="h3" color="primary">
              {data.total_assigned}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper elevation={2} className="p-3 text-center border-start border-success border-4">
            <Typography variant="h6">Processed</Typography>
            <Typography variant="h3" color="success">
              {data.processed_count}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper elevation={2} className="p-3 text-center border-start border-warning border-4">
            <Typography variant="h6">Pending</Typography>
            <Typography variant="h3" color="warning">
              {data.non_processed_count}
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Barcodes Table */}
      <Paper elevation={3} className="p-3">
        <Typography variant="h6" className="mb-3">
          Assigned Samples
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Barcode</strong></TableCell>
                <TableCell><strong>Status</strong></TableCell>
                <TableCell><strong>Date (Rec/Sub)</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.samples && data.samples.length > 0 ? (
                data.samples.map((row) => (
                  <TableRow key={row._id} hover>
                    <TableCell className="fw-bold">{row.barcode}</TableCell>
                    <TableCell>{getStatusChip(row.status)}</TableCell>
                    <TableCell>{formatDate(row.date)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" className="py-4">
                    No samples assigned to this technician.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
    </Container>
  )
}

export default TechnicianDetails